import { Inject, Injectable } from '@angular/core';
import _ from 'lodash';
import { ConfigService } from '../services/config.service';


export interface filtermodel {
type:string;
filter?:string;
filterType:string;
dateFrom?: string;
dateTo?: string;
}

export interface filtermodels {
  [key: string] :  filtermodel
}

export interface SortFilterColumnFilter {
  filter: string;
  filterTo?: string;
  filterType: string;
  type: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface SortFilterRow {
  column1?: string;
  columnfilter1?: SortFilterColumnFilter;
  columnfilter2?: {
    filter?: string;
    filterTo?: string;
    filterType?: string;
    type?: string;
    dateFrom?: string;
    dateTo?: string;
  };
  condition?: string;
}

export interface SortFilterInterface {
  sort?: { colId: string; sort: string }[];
  filter?: {
    Filters?: SortFilterRow[];
    gridFormFilters?: { formFilter?: string; value?: string }[];
  };
  createSortFilter(sortmodal, filtermodal): SortFilterInterface;
}

@Injectable()
export class SortFilter implements SortFilterInterface {
  filter: {
    Filters?: SortFilterRow[];
    gridFormFilters?: { formFilter?: string; value?: string }[];
  };
  sort?: { colId: string; sort: string }[];

  constructor(@Inject(ConfigService) private environment) {
    this.filter = {
      gridFormFilters: [{formFilter: '', value: ''}] ,
      Filters: [{ column1: '',
        columnfilter1: {filter: '', filterTo: '', filterType: '', type: '', dateFrom: '', dateTo: ''},
        columnfilter2: {filter: '', filterTo: '', filterType: '', type: '', dateFrom: '', dateTo: ''},
        condition: ''}] };

  }

  createSortFilter(sortmodal, filtermodal): SortFilterInterface {
    if (this.environment.debug) { console.log('createsortfilter' + sortmodal); }
    if (this.environment.debug) {console.log('filtermodal: ' + filtermodal); }
    if (this.environment.debug) {console.log('filtermodal json: ' + JSON.stringify(filtermodal)); }

    for (let k = 0; k < sortmodal.length; k++) {
      const sortColModel = sortmodal[k];
      if (this.environment.debug) {console.log('colId:' + sortColModel.colId); }
      if (this.environment.debug) {console.log('sort:' + sortColModel.sort); }

      // ===================================================================================================

      // let colid = 'abc';
      // let s = 'asc';
      this.sort ? this.sort.push({colId: sortColModel.colId, sort: sortColModel.sort})
           : this.sort = [{colId: sortColModel.colId, sort: sortColModel.sort}];
      if (this.environment.debug) {console.log('sf:' + JSON.stringify(this)); }

      // ===================================================================================================
    }

     const val = _.get(filtermodal, '[0]');
    if (this.environment.debug) { console.log('val: ' + val); }

    const filterPresent = filtermodal && Object.keys(filtermodal).length > 0;
    if (!filterPresent) {
       delete this.environment;
      return this;
    }

    // Reset Filters before push (constructor empty stub was sent as Filters[0]). 04/06/2026 PK
    // const result = Object.entries(filtermodal).map(([prop, value]) => ({prop, value}));
    this.filter = {
      gridFormFilters: [{ formFilter: '', value: '' }],
      Filters: [],
    };

    const result = Object.entries(filtermodal).map(([prop, value]) => ({prop, value}));
    if (this.environment.debug) {console.log('result' + result); }
    if (result.length > 0) {
      if (this.environment.debug) {console.log(' size = ' + result.length); }
      const a = _.toPairs(filtermodal);

      if (this.environment.debug) {console.log('a:' + a[0]); }


      a.forEach( k => {
        // console.log('k: ' + k);
        if (this.environment.debug) {console.log('k->:' + k[0]); }
        if (filtermodal[k[0]]['condition1']) {
          if (this.environment.debug) { console.log('====' + filtermodal[k[0]]['condition1'].type); }
          if (this.environment.debug) {console.log(`==== type: ${filtermodal[k[0]].condition1.type}
          filter: ${filtermodal[k[0]].condition1.filter} filterType: ${filtermodal[k[0]].condition1.filterType} `); }

          if (this.environment.debug) {console.log(`==== type: ${filtermodal[k[0]].condition2.type}
          filter: ${filtermodal[k[0]].condition2.filter} filterType: ${filtermodal[k[0]].condition2.filterType} `); }

          if (this.environment.debug) {console.log('====' + filtermodal[k[0]].operator); }

          if (this.filter) {
            this.filter.Filters.push({column1: <string>k[0],
              columnfilter1: {
                filter: <string>filtermodal[k[0]].condition1.filter,
                filterTo: <string>filtermodal[k[0]].condition1.filterTo,
                filterType: <string>filtermodal[k[0]].condition1.filterType,
                type: <string>filtermodal[k[0]].condition1.type,
                dateFrom: <string>filtermodal[k[0]].condition1.dateFrom,
                dateTo: <string>filtermodal[k[0]].condition1.dateTo},
              columnfilter2: {
                filter: <string>filtermodal[k[0]].condition2.filter,
                filterTo: <string>filtermodal[k[0]].condition2.filterTo,
                filterType: <string>filtermodal[k[0]].condition2.filterType,
                type: <string>filtermodal[k[0]].condition2.type,
                dateFrom: <string>filtermodal[k[0]].condition2.dateFrom,
                dateTo: <string>filtermodal[k[0]].condition2.dateTo},
              condition: filtermodal[k[0]].operator});
          } else {
            this.filter = {Filters: [{column1: <string>k[0],
                columnfilter1: {
                  filter: <string>filtermodal[k[0]].condition1.filter,
                  filterTo: <string>filtermodal[k[0]].condition1.filterTo,
                  filterType: <string>filtermodal[k[0]].condition1.filterType,
                  type: <string>filtermodal[k[0]].condition1.type,
                  dateFrom: <string>filtermodal[k[0]].condition1.dateFrom,
                  dateTo: <string>filtermodal[k[0]].condition1.dateTo},
                columnfilter2: {
                  filter: <string>filtermodal[k[0]].condition2.filter,
                  filterTo: <string>filtermodal[k[0]].condition2.filterTo,
                  filterType: <string>filtermodal[k[0]].condition2.filterType,
                  type: <string>filtermodal[k[0]].condition2.type,
                  dateFrom: <string>filtermodal[k[0]].condition2.dateFrom,
                  dateTo: <string>filtermodal[k[0]].condition2.dateTo},
                condition: filtermodal[k[0]].operator}]};
          }
        } else {
          if (this.environment.debug) {console.log(`==== type: ${filtermodal[k[0]].type} filter: ${filtermodal[k[0]].filter} filterType: ${filtermodal[k[0]].filterType} `); }
          const colFilter = filtermodal[k[0]];
          const columnfilter1 = {
            filter: <string>(colFilter.filter ?? ''),
            filterType: <string>(colFilter.filterType || 'text'),
            type: <string>(colFilter.type || 'contains'),
            ...(colFilter.filterTo ? { filterTo: <string>colFilter.filterTo } : {}),
            ...(colFilter.dateFrom ? { dateFrom: <string>colFilter.dateFrom } : {}),
            ...(colFilter.dateTo ? { dateTo: <string>colFilter.dateTo } : {}),
          };
          if (this.filter) {
            this.filter.Filters.push({
              column1: <string>k[0],
              columnfilter1,
            });
          } else {
            this.filter = {
              Filters: [{ column1: <string>k[0], columnfilter1 }],
            };
          }
          // if (this.filter) {
          //   this.filter.Filters.push({column1: <string>k[0],
          //     columnfilter1: {
          //       filter: <string>filtermodal[k[0]].filter,
          //       filterTo: <string>filtermodal[k[0]].filterTo,
          //       filterType: <string>filtermodal[k[0]].filterType,
          //       type: <string>filtermodal[k[0]].type,
          //       dateFrom: <string>filtermodal[k[0]].dateFrom,
          //       dateTo: <string>filtermodal[k[0]].dateTo}});
          // } else {
          //   this.filter = {Filters: [{column1: <string>k[0],
          //       columnfilter1: {type: <string>filtermodal[k[0]].type,
          //         filter: <string>filtermodal[k[0]].filter,
          //         filterTo: <string>filtermodal[k[0]].filterTo,
          //         filterType: <string>filtermodal[k[0]].filterType,
          //         dateFrom: <string>filtermodal[k[0]].dateFrom,
          //         dateTo: <string>filtermodal[k[0]].dateTo}}]};
          // }
        }

      });

    }
    delete this.environment;
    return this;
  }

}
